/**
 * api/auth.js — Authentication endpoints
 *
 * POST  /api/auth/login          → { token, user }
 * GET   /api/auth/me             → user object
 * POST  /api/auth/logout         → 204
 * POST  /api/auth/change-password
 */

import client from './client';

export const authApi = {

  /**
   * Login — returns { user, token }.
   * Stores the token + user in localStorage so the client picks them up.
   */
  async login(email, password) {
    const { data } = await client.post('/auth/login', { email, password });
    localStorage.setItem('tayst_token', data.token);
    localStorage.setItem('tayst_user',  JSON.stringify(data.user));
    return data;   // { user, token }
  },

  /**
   * Fetch the current authenticated user.
   */
  async me() {
    const { data } = await client.get('/auth/me');
    return data.user ?? data;
  },

  /**
   * Logout — revokes the token server-side.
   */
  async logout() {
    try {
      await client.post('/auth/logout');
    } catch {
      // Swallow errors (e.g. if token already expired)
    } finally {
      localStorage.removeItem('tayst_token');
      localStorage.removeItem('tayst_user');
    }
  },

  /**
   * Change the current user's password.
   */
  async changePassword(currentPassword, newPassword) {
    const { data } = await client.post('/auth/change-password', {
      current_password:      currentPassword,
      password:              newPassword,
      password_confirmation: newPassword,
    });
    return data;
  },

  /** Read user from localStorage (no API call). */
  storedUser() {
    try {
      const raw = localStorage.getItem('tayst_user');
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },

  /** True if a token exists in localStorage. */
  hasToken() {
    return Boolean(localStorage.getItem('tayst_token'));
  },
};
